import { buildApiUrl } from "./apiConfig";

const ensureFetcher = (fetchWithAuth) => {
  if (typeof fetchWithAuth !== "function") {
    throw new Error("fetchWithAuth is required.");
  }
  return fetchWithAuth;
};

export async function fetchPushRecipients(fetchWithAuth) {
  const runner = ensureFetcher(fetchWithAuth);
  const res = await runner(buildApiUrl("/admin/push-notifications/recipients"));
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new Error(payload?.detail || "Empfänger konnten nicht geladen werden.");
  }
  const payload = await res.json().catch(() => ({}));
  return payload?.recipients ?? [];
}

export async function sendTestPushNotification(fetchWithAuth, payload) {
  const runner = ensureFetcher(fetchWithAuth);
  const res = await runner(buildApiUrl("/admin/push-notifications/test"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const responsePayload = await res.json().catch(() => ({}));
    throw new Error(responsePayload?.detail || "Testbenachrichtigung konnte nicht gesendet werden.");
  }
  return res.json().catch(() => ({}));
}
